//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import { afterNextRender } from "@polymer/polymer/lib/utils/render-status.js";

import "../../../components/desktop/ecourse/EcourseHeader/EcourseHeader";
import "../../../components/desktop/ecourse/EcourseMenuOption/EcourseMenuOption";
import "../../../components/desktop/ecourse//FilterScientific/FilterScientific";
import "../../../components/desktop/ecourse/EcourseList/EcourseList";
import Alodokter from "../../../utils/Alodokter";
import EcourseAnalytics from "../../../analytics/EcourseAnalytics";

class EcoursePage extends PolymerElement {
  static get template() {
    return html `
      <style>
        .container {
          margin: 0 auto;
          padding: 26px 2px 150px;
          display: flex;
          justify-content: space-between;
          gap: 20px;
        }
        .main-container {
          width: 660px;
        }
        .side-container {
          width: 320px;
        }

        .main-container h1 {
          font-weight: 700;
          font-size: 24px;
          line-height: 32px;
          color: #000000;
          border-bottom: 2px solid #ececec;
          padding-bottom: 12px;
        }
      </style>
      <div class="container">
        <!-- SIDE CONTAINER -->
        <div class="side-container">
          <ecourse-menu-option user-uid="{{userUid}}" is-login="{{isLogin}}"></ecourse-menu-option>
          <filter-scientific></filter-scientific>
        </div>
        <!-- SIDE CONTAINER -->

        <!-- MAIN CONTAINER -->
        <div class="main-container">
          <h1>Cari E-Course Sesuai Minat Anda</h1>
          <ecourse-list is-login="{{isLogin}}" user-uid="{{userUid}}" list-ecourses="{{constructListEcourses(listEcourses)}}" page="{{page}}" speciality="{{speciality}}"></ecourse-list>
        </div>
        <!-- MAIN CONTAINER -->
      </div>
    `;
  }

  static get properties() {
    return {
      isLogin: {
        type: Number,
      },
      userUid: {
        type: String,
      },
      listEcourses: {
        type: Object,
      },
      page: {
        type: Number,
      },
      speciality: {
        type: String,
      },
    };
  }

  ready() {
    super.ready();
    afterNextRender(this, function() {
      // Tracker Payment final status is Loaded
      let additionalTracker = ""
      if (this.userUid && this.isLogin) {
        additionalTracker = `user_uid: ${this.userUid} | `
      }
      const eventLabel = `${additionalTracker}device_category: desktop`
      Alodokter.sendEventGA("e-course landing page", "ecourse_landing_viewed", eventLabel);      
    });
  }

  constructListEcourses(listEcourses) {
    return listEcourses.map((listEcourse, index) => ({...listEcourse, index: index}));
  }
}

customElements.define("ecourse-page", EcoursePage);